import { useTranslation } from 'react-i18next';

export const useAdminConversationHeader = () => {
    const { t } = useTranslation();
    return { t };
};
